import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {User} from "types/User"

interface ReturnedType {
    status: "success"
    user: User
}

interface DataProps {
    full_name: string
    email: string
    password?: string
}

export const createStaffUser = createAsyncThunk<ReturnedType, DataProps, AppThunkProps>(
    "staff/create",
    async (data, {signal}) => {
        return api.post<ReturnedType>("/user/create", data, {signal})
    }
)
